import { Component, ElementRef, HostBinding, OnInit } from '@angular/core';
import { inDemoMode, inReadOnlyMode } from '@app/lib/remote-login';
import { SupportModeService } from '@app/services/support-mode.service';

@Component({
  selector: 'remote-login-bar',
  styleUrls: ['./remote-login-bar.component.scss'],
  templateUrl: './remote-login-bar.component.html',
})
export class RemoteLoginBarComponent implements OnInit {
  @HostBinding('class.readonly')
  public get inReadOnlyMode(): boolean {
    return inReadOnlyMode();
  }
  public inDemoMode = inDemoMode();
  private el;

  constructor(elRef: ElementRef, public supportModeService: SupportModeService) {
    this.el = elRef.nativeElement;
  }

  public ngOnInit() {
    // Explicity set style using code so in case of a crash, remote login bar does not become visible
    if (this.supportModeService.inSupportMode || inDemoMode() || inReadOnlyMode()) {
      this.el.style.display = 'block';
    }
  }

  public hideBanner(): void {
    this.el.style.display = 'none';
  }
}
